import React, { useState, useEffect } from 'react';

import { useLocation } from 'react-router-dom';

import { getTeurHabakashaContentData } from '../../server/ServerFunc';
import Section from '../Section';
import DataList from '../DataList';
import AppFooter from '../AppFooter';
import AppHeaderGlobal from '../AppHeaderGlobal';

const BakashalInfo = ({ isSeparate }) => {
  const [systemId, setSystemId] = useState("");
  const [tikDetails, setTikDetails] = useState({});
  const [locationName, setLocationName] = useState("");
  const [baalNechesName, setBaalNechesName] = useState("");
  const [orechHabakashaName, setOrechHabakashaName] = useState("");
  const [archriSheledName, setArchriSheledName] = useState("");
  const [numNotSingNeighbors, setNumNotSingNeighbors] = useState(0);
  const [numAgainstNeighbors, setNumAgainstNeighbors] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [systemCode, setSystemCode] = useState("");

  const search = useLocation().search;

  useEffect(() => {
    const tikNumURL = new URLSearchParams(search).get("TikNum");
		const systemCodeURL = new URLSearchParams(search).get("SystemCode");
    getTeurHabakashaContent(tikNumURL, systemCodeURL);
  }, []);

  const getTeurHabakashaContent = async(tikNum, systemCode) => {
    const bakashaContent = await getTeurHabakashaContentData(tikNum, systemCode);
    setSystemId(systemCode);
    if(Object.keys(bakashaContent).length > 0) {
      setTikDetails(bakashaContent);
      setIsMobile(window.innerWidth < 768);
      setSystemCode(systemCode);
      calcLocationName(bakashaContent);
      calcAgainstAndNotSingedNeighbors(bakashaContent.baaleiInyanList);
      calcBaalNechesOrechHabakashaAndArchriSheled(bakashaContent.baaleiInyanList);
    } else {
      setTikDetails({});
    }
  }

  //functions
  const calcLocationName = (bakashaContent) => {
    let location = "";
    if (bakashaContent.shemRehov) {
      location = `${bakashaContent.shemRehov} ${bakashaContent.misparBait ? bakashaContent.misparBait : ""}, ${bakashaContent.shemSchuna}`
    } else if (bakashaContent.teurMakom) {
      location = `${bakashaContent.teurMakom}`
    } else if (bakashaContent.shemSchuna) {
      location = `${bakashaContent.shemSchuna}`
    } else {
      location = "";
    }

    setLocationName(location);
  }

  const calcAgainstAndNotSingedNeighbors = (baaleiInyanList) => {
    let numOfNotSing = 0;
    let numOfAgainst = 0;

    baaleiInyanList.forEach(neighbor => {
      if(neighbor.sugbaalCode === 28200024) {
        numOfNotSing++;
      }
    });

    baaleiInyanList.forEach(neighbor => {
      if(neighbor.sugbaalCode === 28200009) {
        numOfAgainst++;
      }
    });

    setNumNotSingNeighbors(numOfNotSing);
    setNumAgainstNeighbors(numOfAgainst);
  }

  const calcBaalNechesOrechHabakashaAndArchriSheled = (baaleiInyanList) => {
    const baalNeches = baaleiInyanList.filter(baalInyan => baalInyan.sugbaalCode === 28200002);
    const orechHabakasha = baaleiInyanList.filter(baalInyan => baalInyan.sugbaalCode === 28200006);
    const archriSheled = baaleiInyanList.filter(baalInyan => baalInyan.sugbaalCode === 28200008);

    setBaalNechesName(`${baalNeches[0].prati !== null ? baalNeches[0].prati : ""} ${baalNeches[0].mishpaha !== null ? baalNeches[0].mishpaha : ""}`);
    
    if(orechHabakasha.length > 0) {
      setOrechHabakashaName(`${orechHabakasha[0].prati !== null ? orechHabakasha[0].prati : ""} ${orechHabakasha[0].mishpaha !== null ? orechHabakasha[0].mishpaha : ""}`);
    }
    
    if(archriSheled.length > 0) {
      setArchriSheledName(`${archriSheled[0].prati !== null ? archriSheled[0].prati : ""} ${archriSheled[0].mishpaha !== null ? archriSheled[0].mishpaha : ""}`);
    }
  }

  const pirtyTikData = [
    { key: 'address', label: 'כתובת', value: locationName },
    { key: 'status', label: 'סטטוס', value: tikDetails.teurStatus },
    { key: 'typeBakash', label: 'סוג בקשה', value: tikDetails.teurSugbakashaCodeMulti },
    { key: 'shimushIkary', label: 'שימוש עיקרי', value: tikDetails.teurShimusCodehMulti },
    { key: 'mahutBakash', label: 'מהות בקשה', value: tikDetails.mahutBakasha },
    { key: 'shetachAtar', label: 'שטח האתר', value: tikDetails.shetahAtar },
    { key: 'zchuyotBnia', label: 'שטח לזכויות בנייה', value: tikDetails.shetahZchuyotBniya },
    { key: 'taarichStatus', label: 'תאריך סטטוס', value: tikDetails.taarihStatus },
    { key: 'maslulHatik', label: 'מסלול התיק', value: tikDetails.maslulTik }
  ]

  const baalyInyanData = [
    { key: 'hamevakesh', label: 'המבקש', value: baalNechesName },
    { key: 'orechHabakasha', label: 'עורך הבקשה', value: orechHabakashaName },
    { key: 'achraiSheled', label: 'אחראי שלד', value: archriSheledName },
    { key: 'schenimLoHatmu', label: 'מספר שכנים שלא חתמו', value: numNotSingNeighbors },
    { key: 'schenimMitnagdim', label: 'מספר שכנים מתנגדים', value: numAgainstNeighbors },
    { key: 'achraiTik', label: 'אחראי תיק', value: tikDetails.achraTikFullName },
    { key: 'tzevet', label: 'צוות', value: tikDetails.tzevet }
  ]

  return (
    <>
      { isSeparate && <AppHeaderGlobal /> }
      {
        systemCode === "26400046" ?
          <div style={{ margin: `${isMobile ? "-103px 0px 0px 0px" : (!isSeparate ? "-115px 0px 0px 0px" : "")}`, backgroundColor: "white" }} >
            <div className="container my-3 my-lg-5">
              <Section icon={'clipboard-info'} title={'פרטי תיק'} id={'פרטי תיק'}>
                <DataList
                  style={{ "--label-width": "140px" }}
                  items={pirtyTikData}
                  columns={2}
                />
              </Section>

              <Section icon={'people-connected'} title={'בעלי עניין'} id={'בעלי עניין'}>
                <DataList
                  style={{ "--label-width": "200px" }}
                  items={baalyInyanData}
                  columns={2}
                />
              </Section>

              <Section icon={'form-on-laptop'} title={'תאור הבקשה'} id={'תאור הבקשה'}>
                <div className="teur-habakasha">
                  {
                    tikDetails.teur !== null || tikDetails.teur !== undefined ?
                      <div dangerouslySetInnerHTML={{ __html: tikDetails.teur }} />
                      :
                      <div style={{ textAlign: "center", margin: "auto" }}>אין תיאור</div>
                  }
                </div>
              </Section>
            </div>
          </div>
          :
          <div className="container my-3 my-lg-5">
            <Section icon={'clipboard-info'} title={'פרטי תיק'} id={'פרטי תיק'}>
              <DataList
                style={{ "--label-width": "140px" }}
                items={pirtyTikData}
                columns={2}
              />
            </Section>

            <Section icon={'people-connected'} title={'בעלי עניין'} id={'בעלי עניין'}>
              <DataList
                style={{ "--label-width": "200px" }}
                items={baalyInyanData}
                columns={2}
              />
            </Section>

            <Section icon={'form-on-laptop'} title={'תאור הבקשה'} id={'תאור הבקשה'}>
              <div className="teur-habakasha">
                {
                  tikDetails.teur !== null || tikDetails.teur !== undefined ?
                    <div dangerouslySetInnerHTML={{ __html: tikDetails.teur }} />
                    :
                    <div style={{ textAlign: "center", margin: "auto" }}>אין תיאור</div>
                }
              </div>
            </Section>
          </div>
      }
      { isSeparate && <AppFooter /> }
    </>
  )
}

export default BakashalInfo